import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

// components
import { styled, Typography } from '@mui/material';

// utils
import {
  setAccountDetails,
  setAdminDetails,
} from '../../../_tabs/tabs.reducer';
import { determineIfAllowedScopes } from '../../../../utils/next/auth.utils';
import { useScopes } from '../../../../components/hooks/useScopes';
import { usePersona } from '../../../../components/hooks/usePersona';
import { useGetAccountProfileLink } from '../../../../components/hooks/useGetAccountProfileLink';

export const CowbellAccountProfileLink = ({ account }: any) => {
  const handleLink = useLinkToAccountProfile({ account });
  const accountProfileLink = useGetAccountProfileLink(account.id);
  return (
    <Link
      className="link-underlined--hover"
      to={accountProfileLink}
      onClick={handleLink}
    >
      <EditAccountProfileText>EDIT ACCOUNT PROFILE</EditAccountProfileText>
    </Link>
  );
};

export const useLinkToAccountProfile = ({ account }: any) => {
  const scopes = useScopes();
  const persona = usePersona();
  const dispatch = useDispatch();
  const location = useLocation();

  return React.useCallback(() => {
    const canManageAccountProfile = determineIfAllowedScopes(
      scopes,
      ['account_profile:manage'],
      true
    );
    const canDocDelete = determineIfAllowedScopes(
      scopes,
      ['account:cowbell'],
      true
    );
    const canManageAccounts = determineIfAllowedScopes(
      scopes,
      ['accounts:manage'],
      true
    );

    dispatch(
      setAccountDetails({
        account: {
          companyName: account.name,
          quoteNumber: '',
          accountId: account.id,
        },
      })
    );

    if (persona.isCowbell) {
      dispatch(
        setAdminDetails({
          admin: {
            from: '/admin/accounts',
            readOnly: {
              quote: false,
              policy: true,
              account: !canManageAccountProfile,
              risk: true,
              documents: {
                upload: false,
                delete: !canDocDelete,
              },
              notes: false,
            },
          },
        })
      );
    }
  }, [scopes, dispatch, account.name, account.id, persona.isCowbell]);
};

const EditAccountProfileText = styled(Typography)(({ theme: { config } }) => ({
  color: config.colors.cowbellBlue,
  fontSize: config.textSizes.tertia,
  fontWeight: config.weights.bold,
  textTransform: 'uppercase',
}));
